import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'OrderDetails' | 'OrderDetailsHeader' | 'OrderInformation';

/**
 * Errors related to the Order Details page
 */
export const Errors = createErrors<Page, Component>('OrderDetails')({
    OrderDetails: {
        GetOrderFailed: {
            severity: 'MEDIUM',
            message: 'Failed to fetch order details',
        },
        FetchProductsAndInventoriesFailed: {
            severity: 'MEDIUM',
            message: 'Failed to fetch products and inventories',
        },
    },
    OrderDetailsHeader: {
        HandleBuyAllAgainFailed: {
            severity: 'HIGH',
            message: 'Failed to add items to cart',
        },
    },

    OrderInformation: {
        ButtonConfigsProductOrderableFailed: {
            severity: 'MEDIUM',
            message: 'Failed to get product orderable',
        },
        RedirectToPDPFailed: {
            severity: 'MEDIUM',
            message: 'Failed to redirect to PDP',
        },
    },
});
